import n from "./index828.js";
function i(t) {
  return n(t) ? void 0 : t;
}
export {
  i as default
};
